import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getQueryGetDto } from '../ServiceController';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { Button, Table, Row, Col, Form, Alert } from 'react-bootstrap';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { RefertoContext } from 'app/context/RefertoContext';
import { collectionDiagnosi } from '../Fse/collectionCode';

const GrigliaDiagnosi = ({ isSingolo = false }) => {
    const dispatch = useDispatch();
    const { state: referto, dispatch: dispatchReferto } = useContext(RefertoContext);
    const [selectedItems, setSelectedItems] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [selectedItem, setSelectedItem] = useState(null);
    const [diagnosiReferto, setDiagnosiReferto] = useState([]);
    const [selectedDiagnosi, setSelectedDiagnosi] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [quesito, setQuesito] = useState('');
    const searchTimeout = useRef(null);
    const [erroreValidazione, setErroreValidazione] = useState('');

    useEffect(() => {
        if (referto.diagnosi?.items) setSelectedItems(referto.diagnosi.items);
        if (referto.diagnosi?.quesito) setQuesito(referto.diagnosi.quesito);
    }, [referto.diagnosi]);

    const handleSearch = (query) => {
        if (searchTimeout.current) {
            clearTimeout(searchTimeout.current);
        }
        searchTimeout.current = setTimeout(() => {
            if (query.trim() === '') return;
            setIsLoading(true);
            const payload = {
                nomeCollection: collectionDiagnosi,
                campo: "description",
                valore: query
            };
            dispatch(getQueryGetDto('MongoDb/GetRisultatiMongo', payload))
                .then((results) => {
                    let transformedResults = results && results.length > 0
                        ? results.map(r => r.dati)
                        : [];
                    if (transformedResults.length > 0) {
                        transformedResults = transformedResults.sort((a, b) => a.description.localeCompare(b.description));
                    }
                    setDiagnosiReferto(transformedResults);
                    setIsLoading(false);
                })
                .catch(error => {
                    console.error('Errore nel servizio MongoDB:', error);
                    setIsLoading(false);
                });
        }, 300);
    };

    const addItem = () => {
        if (selectedItem) {
            const updatedItems = isSingolo
                ? [selectedItem]
                : [...selectedItems, selectedItem];

            setSelectedItems(updatedItems);
            dispatchReferto({ type: "UPDATE_FIELD", field: "diagnosi", payload: { quesito, items: updatedItems } });

            setInputValue('');
            setSelectedItem(null);
            setSelectedDiagnosi([]);
        }
    };

    const deleteItem = (id) => {
        const updatedItems = selectedItems.filter(item => item.id !== id);
        setSelectedItems(updatedItems);
        dispatchReferto({
            type: "UPDATE_FIELD",
            field: "diagnosi",
            payload: { quesito, items: updatedItems },
        });
    };

    // mantieni locale mentre scrivi
    const handleQuesitoChange = (e) => {
        setQuesito(e.target.value);
    };

    // fai commit SOLO quando esci dal campo (oppure aggiungi anche un pulsante “Salva”)
    const commitQuesito = () => {
        dispatchReferto({
            type: "UPDATE_FIELD",
            field: "diagnosi",
            payload: { quesito, items: selectedItems },
        });
    };

    return (
        <div className='container'>
            {erroreValidazione && (
                <Alert variant="warning">
                    {erroreValidazione}
                </Alert>
            )}
            <Form.Group className="mb-4">
                <Form.Label>Quesito Diagnostico</Form.Label>
                <Form.Control
                    as="textarea"
                    rows={3}
                    value={quesito}
                    onChange={handleQuesitoChange}
                    onBlur={commitQuesito}
                    placeholder="Inserisci qui il quesito diagnostico..."
                />
            </Form.Group>
            <Row className="align-items-center mb-4">
                <Col md={10}>
                    <AsyncTypeahead
                        id="idDiagnosi"
                        placeholder="Inserisci il nome o il codice della diagnosi..."
                        onSearch={handleSearch}
                        labelKey="description"
                        selected={selectedDiagnosi}
                        onChange={(selected) => {
                            if (selected.length > 0) {
                                setSelectedItem({
                                    codice: selected[0].code,
                                    descrizione: selected[0].description,
                                    diagnosi: selected[0].description,
                                    id: selected[0]._id || selected[0].code
                                });
                                setSelectedDiagnosi(selected);
                            } else {
                                setSelectedDiagnosi([]);
                            }
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && selectedItem) {
                                e.preventDefault();
                                addItem();
                            }
                        }}
                        options={diagnosiReferto}
                        className="diagnosi-typeahead"
                        isLoading={isLoading}
                    />
                </Col>
                <Col md={2} className="text-end">
                    <Button
                        variant="primary"
                        onClick={addItem}
                        className="w-100"
                    >
                        <i className="bi bi-plus-circle me-2"></i>Aggiungi
                    </Button>
                </Col>
            </Row>

            <hr className='bg-primary' />
            <h5 className="mb-2">{isSingolo ? "Diagnosi Selezionata - " : "Diagnosi Selezionate "}
                {isSingolo && <small>(è possibile selezionare solo una diagnosi)</small>}
            </h5>

            <Table className='striped bordered hover'>
                <thead className="table">
                    <tr>
                        <th style={{ width: '20%' }}>Codice</th>
                        <th style={{ width: '60%' }}>Descrizione</th>
                        <th style={{ width: '20%' }} className="text-center">Azione</th>
                    </tr>
                </thead>
                <tbody>
                    {selectedItems.map((item) => (
                        <tr key={item.codice + '_' + item.descrizione}>
                            <td>{item.codice}</td>
                            <td>{item.descrizione}</td>
                            <td className="text-center">
                                <Button
                                    variant="danger"
                                    className='text-white'
                                    onClick={() => deleteItem(item.id)}
                                >
                                    <i className="bi bi-trash-fill me-2"></i>Cancella
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default GrigliaDiagnosi;
